import { useParams } from "react-router-dom";
import { Card, Link, CardContent, styled, Box } from "@mui/material";
import BarekamText from "../../../components/text";

import { useAppSelector } from "../../../../redux/store";

const CardWrapper = styled(Card) <{ defaultWith?: boolean }>`
    flex: 1;
    height: 360px;
    background-color: #F8F9FA;
    padding: 16px;

    @media screen and (max-width: 960px) {
      min-width: 320px;
      flex-direction: column;
    }
`;

export const CardContentWrapper = styled(CardContent)`
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
  padding: 0;

  span {
    color: #2a2e3c;
  }
`;

export const LinkWrapper = styled(Link)`
    display: flex;
    height: 100%;
    flex-direction: column;
    gap: 16px;
`;

const ImageWrapper = styled('div')`
    width: 100%;
    height: 200px;
`;

type ItemProps = {
  id: number;
  title: string;
  description: string;
  shortDescription: string;
  imgUrl?: string;
  slug: string;
  defaultWith?: boolean
};

const CardItem = ({ slug, title, shortDescription, imgUrl, defaultWith }: ItemProps) => {
  const { language } = useParams();
  const { languageId } = useAppSelector((state) => state.messagesReducer);

  return (
    <CardWrapper defaultWith={defaultWith}>
      <LinkWrapper href={`/${language}/blog/${slug}`}>
        <CardContentWrapper>
          <BarekamText variant={"m"} fontWeight={600} align={"center"}>
            {title[languageId]}
          </BarekamText>
          {shortDescription && (
            <BarekamText variant={"s"} fontWeight={500} align={"center"}>
              {shortDescription[languageId]?.slice(0, 200)}
            </BarekamText>
          )}
        </CardContentWrapper>
        {imgUrl && (
          <ImageWrapper>
            <Box
              component="img"
              src={imgUrl}
              alt={title[languageId]}
              sx={{
                width: '100%',
                maxWidth: '100%',
                maxHeight: '100%',
                objectFit: 'cover'
              }}
            />
          </ImageWrapper>
        )}
      </LinkWrapper>
    </CardWrapper>
  );
};

export default CardItem;
